import {
  FiGrid,
  FiShield,
  FiBriefcase,
  FiSquare,
  FiAward,
  FiArchive,
  FiLayers,
  FiFolder,
  FiList,
  FiImage,
  FiShoppingCart,
  FiAlertTriangle,
  FiFileText,
} from 'react-icons/fi';

const crud = (base) => [
  { titre: 'Lister', link: base },
  { titre: 'Ajouter', link: `${base}/ajouter` },
];

export const SidebarData = [
  {
    section: 'Tableau de bord',
    items: [
      { titre: 'Dashboard', link: '/admin', icon: <FiGrid /> },
    ],
  },
  {
    section: 'Catalogue',
    items: [
      { titre: 'Bureau', icon: <FiBriefcase />, children: crud('/admin/Bureaux') },
      { titre: 'Table', icon: <FiSquare />, children: crud('/admin/Table') },
      { titre: 'Chaise', icon: <FiAward />, children: crud('/admin/Chaise') },
      { titre: 'Armoire', icon: <FiArchive />, children: crud('/admin/Armoire') },
      { titre: 'Comptoir', icon: <FiLayers />, children: crud('/admin/Comptoir') },
    ],
  },
  {
    section: 'Organisation',
    items: [
      { titre: 'Catégorie', icon: <FiFolder />, children: crud('/admin/Catégorie') },
      { titre: 'Sous-Catégorie', icon: <FiList />, children: crud('/admin/Sous-Catégorie') },
    ],
  },
  {
    section: 'Contenu',
    items: [
      { titre: 'Carousel', icon: <FiImage />, children: crud('/admin/Carousel') },
      { titre: 'Nos actualités', icon: <FiFileText />, children: crud('/admin/Actualite') },
    ],
  },
  {
    section: 'Gestion',
    items: [
      { titre: 'Commandes', link: '/admin/Commande', icon: <FiShoppingCart /> },
      { titre: 'Réclamations', link: '/admin/Reclamation', icon: <FiAlertTriangle /> },
      { titre: 'Admin', icon: <FiShield />, children: crud('/admin/Registre') },
    ],
  },
];
